<!--
 * @Author: your name
 * @Date: 2022-04-13 10:23:41
 * @LastEditTime: 2022-04-13 15:01:41
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\reportRecord\test.vue
-->
<!--
 * @Author: your name
 * @Date: 2022-04-11 20:23:02
 * @LastEditTime: 2022-04-12 21:22:45
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jk_one-stop_cloud_mobile_v1.0\src\views\reportRecord\recordDetail.vue
-->

<template>
  <div class="detail" >
    <Navbar :appTitle="title" />
       <van-tabs class="ddsdsd"  v-model="active" scrollspy sticky  offset-top="0.45rem"> 
        <van-tab v-for="index in 8" :key="index" :title="'标签 ' + index" class="ewewewe">
         <div>标签{{index}}</div>
         <div> 1</div>
         <div> 2</div>
         <div> 3</div>
         <div> 4</div>
         <div> 5</div>
         <div> 6</div>
         <div> 7</div>
         <div> 8</div>
         <div> 9</div>
         <div> 10</div>
         <div> 11</div>
         <div> 12</div>
         <div> 13</div>
        </van-tab>
      </van-tabs> 
     

      
  </div>
</template>
<script>
import Navbar from "@/components/navBar/navBar_right";

export default {
  name: "detail",
  components: { Navbar },
  data() {
    return {
      title: this.$route.meta.title,
    
      active: 0,
    };
  },
  computed: {},
  mounted() {},
  created() {
   
  },
  methods: {
     
  },
};
</script>
<style lang="scss" scoped>
.detail {
  height: 100vh;
  overflow-y: scroll;
  // padding: 10px;
    

}
</style>
<style>
.van-tabs__line {
      background-color: #1890FF;
}
.van-tab--active{
color: #1890FF;
}


</style>